import React from "react";
import { Box, ListItemButton, Typography } from "@mui/material";

import {
  getNotificationIconType,
  getNotificationPreview,
  getNotificationRelativeTime,
  getNotificationTicketLabel,
  getNotificationTitle,
} from "../notificationUtils";
import NotificationEventAvatar from "./NotificationEventAvatar";
import { SanitizedHtml } from "../../../../../utils";

function NotificationItem({ notification, isUnread, onClick }) {
  console.log("notification",notification)
  return (
    <ListItemButton
      className={`notification-item${isUnread ? " unread" : ""}`}
      onClick={() => onClick(notification)}
    >
      <NotificationEventAvatar
        actor={notification.actor}
        type={getNotificationIconType(notification.event_type)}
        showUnreadDot={isUnread}
      />

      <Box className="notification-content">
        <Box className="notification-row">
          <Typography className="notification-item-title">
            {getNotificationTitle(notification)}
          </Typography>
        </Box>

        <Typography className="notification-item-preview">
          <SanitizedHtml as="div" html={getNotificationPreview(notification)} />
        </Typography>

        <Box className='notification-item-bottom'>
        <Typography className="notification-item-ticket">
          {getNotificationTicketLabel(notification)}
          </Typography>
          <Typography className="notification-item-time">
            {getNotificationRelativeTime(notification.created_at)}
          </Typography>
          </Box>
      </Box>
    </ListItemButton>
  );
}

export default React.memo(NotificationItem);
